import React, { useRef } from "react";
import { Footer } from "./Footer";
import Brands from "./Brands";
import emailjs from "emailjs-com";
import { useTranslation } from "react-i18next";
import { Col, Container, Row, Card } from "react-bootstrap";
import GoTop from "./GoTop";
import Navigation from "./Navigation";

// Images
import bgImage from "../Assets/img/bgs/rawbg.png";
import raw from "../Assets/img/rawsteel.png";

// Placeholder Images (Find these on Freepik)
import aboutImg from "../Assets/img/raw-about.jpg"; // Search: "Industrial steel plant exterior"
import colorCoilImg from "../Assets/img/raw-color-coil.jpg"; // Search: "Painted steel coils warehouse"
import galvCoilImg from "../Assets/img/raw-galv-coil.jpg"; // Search: "Shiny galvanized steel rolls"
import processImg from "../Assets/img/raw-process.jpg"; // Search: "Steel manufacturing line"

const RawSteel = ({ lang: currentLanguage }) => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_inyaa89",
        "template_993qouc",
        form.current,
        "user_DfrMcD1i8Klde4wR1m0qR"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    form.current.reset();
  };

  const { t } = useTranslation();

  const aboutTextClass = () => {
    switch (currentLanguage.code) {
      case 'en': return 'about-text-en';
      case 'ar': return 'about-text-ar';
      case 'kur': return 'about-text-kur';
      default: return '';
    }
  };

  const menu = ["about", "Raw Steel"];

  return (
    <>
      <Navigation navs={menu} />
      
      {/* HERO SECTION */}
      <div id="rs-head">
        <div className="hero-motion-container">
          <img src={bgImage} className="hero-motion-bg" alt="Raw Steel Background" />
          <div className="hero-motion-overlay">
            <img src={raw} className="hero-motion-logo" alt="Raw Steel Logo" />
            <h3 style={{ color: 'rgba(0,0,0)', fontWeight: '700', textShadow: '2px 2px 4px rgba(0,0,0,0.7)', marginTop: '20px', textAlign: 'center', padding: '0 20px' }}>
              {t("rs_slogan")}
            </h3>
          </div>
        </div>
      </div>

      <Brands />

      {/* ABOUT SECTION (Replaced Video with Image) */}
      <div id="about" className="s-about pt-5" data-aos="fade-up" data-aos-duration="1000">
        <div className="s-about-inner">
          <Container>
            <Row className="align-items-center">
              <Col md={6} className="mb-4 mb-md-0 d-flex justify-content-center">
                <img src={aboutImg} className="img-fluid rounded shadow" alt="Raw Steel Facility" />
              </Col>
              <Col md={6} className="about-us">
                <div className={`about-text ${aboutTextClass()}`}>
                  <h2 className={`${currentLanguage.dir === "ltr" ? "h2Font" : "h2rtl"}`}>
                    {t("rs_about_title")}
                  </h2>
                  <div className="mb-4"><hr className="hr" style={{ width: "80px", borderTop: "3px solid #0521a9" }}/></div>
                  <p>{t("rs_about_desc1")}</p>
                  <p>{t("rs_about_desc2")}</p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      {/* VISION & MISSION */}
      <div className="rs-vision-section py-5 bg-light" data-aos="fade-up" data-aos-duration="1000">
        <Container>
          <Row>
            <Col md={6} className="mb-4">
              <Card className="h-100 shadow-sm border-0 rs-card">
                <Card.Body>
                  <h3 className={`${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"} text-primary mb-3`}>{t("rs_vision_title")}</h3>
                  <p>{t("rs_vision_desc")}</p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} className="mb-4">
              <Card className="h-100 shadow-sm border-0 rs-card">
                <Card.Body>
                  <h3 className={`${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"} text-primary mb-3`}>{t("rs_mission_title")}</h3>
                  <p>{t("rs_mission_desc")}</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* PRODUCTS & CAPACITY */}
      <div className="rs-products-section py-5" data-aos="fade-up">
        <Container>
          <div className="text-center mb-5">
            <h2 className={`${currentLanguage.dir === "ltr" ? "h2Font" : "h2rtl"}`}>{t("rs_products_title")}</h2>
            <p className="lead">{t("rs_products_desc")}</p>
          </div>
          <Row>
            <Col md={6} className="mb-4">
              <div className="rs-product-box text-center p-3 border rounded shadow-sm">
                <img src={colorCoilImg} className="img-fluid rounded mb-3" alt="Color Coils" style={{ height: '250px', objectFit: 'cover', width: '100%' }} />
                <h4 className="text-primary">{t("rs_prod1_title")}</h4>
                <p>{t("rs_prod1_desc")}</p>
              </div>
            </Col>
            <Col md={6} className="mb-4">
              <div className="rs-product-box text-center p-3 border rounded shadow-sm">
                <img src={galvCoilImg} className="img-fluid rounded mb-3" alt="Galvanized Coils" style={{ height: '250px', objectFit: 'cover', width: '100%' }} />
                <h4 className="text-primary">{t("rs_prod2_title")}</h4>
                <p>{t("rs_prod2_desc")}</p>
              </div>
            </Col>
          </Row>

          {/* TARGET SECTORS */}
          <div className="rs-sectors mt-5 p-4 bg-light rounded">
            <h4 className={`mb-4 ${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"}`}>🏭 {t("rs_target_sectors_title")}</h4>
            <ul className="rs-sector-list" style={{ lineHeight: '2' }}>
              <li>{t("rs_sector1")}</li>
              <li>{t("rs_sector2")}</li>
              <li>{t("rs_sector3")}</li>
              <li>{t("rs_sector4")}</li>
            </ul>
          </div>
        </Container>
      </div>

      {/* PRODUCTION PROCESS */}
      <div className="rs-process-section py-5 text-white" style={{ backgroundColor: '#0521a9' }}>
        <Container>
          <Row className="align-items-center">
            <Col lg={5} className="mb-4 mb-lg-0">
              <h2 className={`${currentLanguage.dir === "ltr" ? "h2Font2" : "h2rtl"} mb-4`}>{t("rs_process_title")}</h2>
              <p>{t("rs_process_desc")}</p>
              <img src={processImg} className="img-fluid rounded shadow mt-3" alt="Process Line" />
            </Col>
            <Col lg={7}>
              <div className="rs-process-steps p-md-4">
                {[1, 2, 3, 4, 5, 6, 7].map((step) => (
                  <div key={step} className="d-flex mb-3 align-items-start">
                    <div className="rs-step-number bg-white text-primary fw-bold rounded-circle text-center me-3 ms-3 d-flex justify-content-center align-items-center" style={{ minWidth: '40px', height: '40px' }}>
                      {step}
                    </div>
                    <div>
                      <h5 className="mb-1 rs-step-title">{t(`rs_step${step}_title`)}</h5>
                      <p className="mb-0 text-light opacity-75">{t(`rs_step${step}_desc`)}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* ENVIRONMENT & SWOT */}
      <div className="rs-env-swot py-5">
        <Container>
          <Row>
            {/* Environment */}
            <Col md={6} className="mb-4">
              <h3 className={`${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"} mb-4`}>{t("rs_env_title")}</h3>
              <div className="mb-3">
                <strong className="text-success fs-5">{t("rs_env_sub1")}</strong>
                <p>{t("rs_env_desc1")}</p>
              </div>
              <div>
                <strong className="text-info fs-5">{t("rs_env_sub2")}</strong>
                <p>{t("rs_env_desc2")}</p>
              </div>
            </Col>
            
           {/* SWOT / WHY CHOOSE US SECTION */}
<Col md={6} className="mb-4">
  {/* Section Title Container with Accent Bar */}
  <div className="rs-section-title-container mb-4">
  <span className="rs-title-accent-bar"></span>
  <h3 className={`rs-swot-title d-inline-block m-0 ${currentLanguage.dir === "ltr" ? "h2Font" : "h3rtl"}`}>
    {t("rs_swot_title")}{currentLanguage.code === 'en' ? '?' : ''}
  </h3>
</div>

  {/* Stacked Cards List Container with Original Content */}
  <div className="rs-swot-stack">
    
    {/* Card 1 */}
    <div className="rs-swot-card-item">
      <h5 className="rs-card-title">{t("rs_swot1_title")}</h5>
      <p className="rs-card-desc">{t("rs_swot1_desc")}</p>
    </div>
    
    {/* Card 2 */}
    <div className="rs-swot-card-item">
      <h5 className="rs-card-title">{t("rs_swot2_title")}</h5>
      <p className="rs-card-desc">{t("rs_swot2_desc")}</p>
    </div>
    
    {/* Card 3 */}
    <div className="rs-swot-card-item">
      <h5 className="rs-card-title">{t("rs_swot3_title")}</h5>
      <p className="rs-card-desc">{t("rs_swot3_desc")}</p>
    </div>

  </div>
</Col>
          </Row>
        </Container>
      </div>

      <Container className="py-5 text-center border-top">
        <img src={raw} className="w-25 mb-4" alt="Raw Steel" />
      </Container>

      {/* CONTACT (Kept intact as requested) */}
      <div id="contact">
        <div className="overlay" style={{ backgroundColor: 'contact', color: '#fff' }}>
          <Container>
            <Row>
              <Col lg={{ span: 6, order: 1 }} className="text-center px-4 py-5 mx-auto">
                <h3 className={`s-about-title mb-4 ${currentLanguage.dir === "ltr" ? "h2Font" : "h2rtl"}`}>
                  {t("Raw Steel")}
                </h3>
                <p className="px-md-5">{t("Raw Steel is a strategic and unprecedented industrial project in Iraq and the Kurdistan Region, specializing in the painting, coating, and galvanizing of steel sheets and coils.")}</p>
                <h6 className="text-warning mb-2">{t("address")}</h6>
                <p className="px-md-5">{t("rs_address_value")}</p>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      <Footer />
      <GoTop id="rs-head" />
    </>
  );
};

export default RawSteel;